export default class fileUtils {
    static getFileNameFromResponse(httpResponse) {
        var contentDisposition = httpResponse.headers.get('Content-Disposition');
        const filename = contentDisposition && /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
        return filename && filename.replace(/['"]/g, '');
    }
};
